// Local image imports
const homeImg = require('../assets/home.png')
const productImg = require('../assets/product.png')
const caseImg = require('../assets/case.png')
const contactImg = require('../assets/contact.png')
const aboutImg = require('../assets/about.png')
const newsImg = require('../assets/news.png')

export const localImages = {
  home: homeImg,
  product: productImg,
  case: caseImg,
  contact: contactImg,
  about: aboutImg,
  news: newsImg,
}
